module.exports = __webpack_public_path__ + "img/11_10.953fbc12.png";